import { useEffect, useState } from "react";

/**
 * Reusable HEX input with gray `#` prefix block seamlessly attached.
 * Keeps a local draft so partial typing (1–2 chars) doesn't blank the color.
 * Commits on valid 3- or 6-char hex or empty.
 */
export default function HexInput({ value, onChange, testid, label }) {
  const normalize = (v) => (v || "").replace("#", "").toUpperCase();
  const [draft, setDraft] = useState(normalize(value));
  useEffect(() => { setDraft(normalize(value)); }, [value]);

  const handle = (raw) => {
    const clean = (raw || "").replace(/[^0-9a-fA-F]/g, "").slice(0, 6).toUpperCase();
    setDraft(clean);
    if (clean.length === 3 || clean.length === 6) onChange(clean);
    else if (clean.length === 0) onChange("");
  };

  return (
    <label className="block cursor-text">
      {label && <div className="text-[11px] uppercase tracking-widest text-gray-500 mb-1 select-none">{label}</div>}
      <div className="flex items-stretch h-10 bg-white rounded-md border border-gray-200 focus-within:border-[var(--bh-accent,#fe7f57)] overflow-hidden transition-colors">
        <span className="w-10 flex items-center justify-center bg-gray-100 text-gray-400 text-sm font-mono select-none border-r border-gray-200">#</span>
        <input
          data-testid={testid}
          value={draft}
          onChange={(e) => handle(e.target.value)}
          className="flex-1 min-w-0 px-3 text-sm bg-white font-mono uppercase focus:outline-none focus-visible:outline-none"
          maxLength={6}
          placeholder="000000"
        />
      </div>
    </label>
  );
}
